import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { STheme } from "components/styles";
import { RecoilRoot } from "recoil";
import {
  B000010,
  B000011,
  B000020,
  B000110,
  B000111,
  B000120,
  B000130,
  B000140,
  B000150,
  B000151,
  B000160,
  B000170,
  B000180,
  B000190,
  B000200,
  B000201,
  B000202,
  B000220,
  B000221,
  B000222,
  B000223,
  B000224,
  B000230,
  B010010,
  B010011,
  B010012,
  B010020,
  B010030,
  B010040,
  B010050,
  B010060,
  B010070,
  B010080,
  B020010,
  B020011,
  B020012,
  B020020,
  B020030,
  B020040,
  B020050,
  B030010,
  B030020,
  B030030,
  B030040,
  B030050,
  B030051,
  B030060,
  B030070,
  B030080,
  B040010,
  B040020,
  B040030,
  B040040,
  B050010,
  B050011,
  B050020,
  B050030,
  B060010,
  B060020,
  B060030,
  B070010,
  B070020,
  B080010,
  B080020,
  B080030,
  B080040,
  B080050,
  B080060,
  B080070,
  B080080,
  B080090,
  B090010,
  B090011,
  B090012,
  B090013,
  B090014,
  B090015,
  B090016,
  B090020,
  B090021,
  B090030,
  B090040,
  B090050,
  B090051,
  B090060,
  B100040,
  B100050,
  B100060,
  B100063,
  B100070,
  B100073,
  B100080,
  B100083,
  B100090,
  B100100,
  B100110,
  B100113,
  B100120,
  B100130,
  B100133,
  B100140,
  B100143,
  B100150,
  B100153,
  B100180,
  B100183,
  B100190,
  B100193,
  B100200,
  B100210,
  B100220,
  B100223,
  B100230,
  B100900,
  B100910,
  B110010,
  B110020,
  B110030,
  B110040,
} from "pages";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  Components,
  Components2,
  Components3,
  Components4,
} from "components/Components";
import { SProgress } from "components/parts";

export const App = () => {
  return (
    <ThemeProvider theme={STheme}>
      <RecoilRoot>
        <CssBaseline />
        <Router />
        <SProgress />
      </RecoilRoot>
    </ThemeProvider>
  );
};

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/components" element={<Components />} />
        <Route path="/components2" element={<Components2 />} />
        <Route path="/components3" element={<Components3 />} />
        <Route path="/components4" element={<Components4 />} />
        <Route path="/test/b000011" element={<B000011 />} />
        <Route path="/test/b000020" element={<B000020 />} />
        <Route path="/test/b000110" element={<B000110 />} />
        <Route path="/test/b000111" element={<B000111 />} />
        <Route path="/test/b000120" element={<B000120 />} />
        <Route path="/test/b000130" element={<B000130 />} />
        <Route path="/test/b000140" element={<B000140 />} />
        <Route path="/test/b000150" element={<B000150 />} />
        <Route path="/test/b000151" element={<B000151 />} />
        <Route path="/test/b000160" element={<B000160 />} />
        <Route path="/test/b000170" element={<B000170 />} />
        <Route path="/test/b000180" element={<B000180 />} />
        <Route path="/test/b000190" element={<B000190 />} />
        <Route path="/test/b000200" element={<B000200 />} />
        <Route path="/test/b000201" element={<B000201 />} />
        <Route path="/test/b000202" element={<B000202 />} />
        <Route path="/test/b000220" element={<B000220 />} />
        <Route path="/test/b000221" element={<B000221 />} />
        <Route path="/test/b000222" element={<B000222 />} />
        <Route path="/test/b000223" element={<B000223 />} />
        <Route path="/test/b000224" element={<B000224 />} />
        <Route path="/test/b000230" element={<B000230 />} />
        <Route path="/test/b010010" element={<B010010 />} />
        <Route path="/test/b010011" element={<B010011 />} />
        <Route path="/test/b010012" element={<B010012 />} />
        <Route path="/test/b010020" element={<B010020 />} />
        <Route path="/test/b010030" element={<B010030 />} />
        <Route path="/test/b010040" element={<B010040 />} />
        <Route path="/test/b010050" element={<B010050 />} />
        <Route path="/test/b010060" element={<B010060 />} />
        <Route path="/test/b010070" element={<B010070 />} />
        <Route path="/test/b010080" element={<B010080 />} />
        <Route path="/test/b020010" element={<B020010 />} />
        <Route path="/test/b020011" element={<B020011 />} />
        <Route path="/test/b020012" element={<B020012 />} />
        <Route path="/test/b020020" element={<B020020 />} />
        <Route path="/test/b020030" element={<B020030 />} />
        <Route path="/test/b020040" element={<B020040 />} />
        <Route path="/test/b020050" element={<B020050 />} />
        <Route path="/test/b030010" element={<B030010 />} />
        <Route path="/test/b030020" element={<B030020 />} />
        <Route path="/test/b030030" element={<B030030 />} />
        <Route path="/test/b030040" element={<B030040 />} />
        <Route path="/test/b030050" element={<B030050 />} />
        <Route path="/test/b030051" element={<B030051 />} />
        <Route path="/test/b030060" element={<B030060 />} />
        <Route path="/test/b030070" element={<B030070 />} />
        <Route path="/test/b030080" element={<B030080 />} />
        <Route path="/test/b040010" element={<B040010 />} />
        <Route path="/test/b040020" element={<B040020 />} />
        <Route path="/test/b040030" element={<B040030 />} />
        <Route path="/test/b040040" element={<B040040 />} />
        <Route path="/test/b050010" element={<B050010 />} />
        <Route path="/test/b050011" element={<B050011 />} />
        <Route path="/test/b050020" element={<B050020 />} />
        <Route path="/test/b050030" element={<B050030 />} />
        <Route path="/test/b060010" element={<B060010 />} />
        <Route path="/test/b060020" element={<B060020 />} />
        <Route path="/test/b060030" element={<B060030 />} />
        <Route path="/test/b070010" element={<B070010 />} />
        <Route path="/test/b070020" element={<B070020 />} />
        <Route path="/test/b080010" element={<B080010 />} />
        <Route path="/test/b080020" element={<B080020 />} />
        <Route path="/test/b080030" element={<B080030 />} />
        <Route path="/test/b080040" element={<B080040 />} />
        <Route path="/test/b080050" element={<B080050 />} />
        <Route path="/test/b080060" element={<B080060 />} />
        <Route path="/test/b080070" element={<B080070 />} />
        <Route path="/test/b080080" element={<B080080 />} />
        <Route path="/test/b080090" element={<B080090 />} />
        <Route path="/test/b090010" element={<B090010 />} />
        <Route path="/test/b090011" element={<B090011 />} />
        <Route path="/test/b090012" element={<B090012 />} />
        <Route path="/test/b090013" element={<B090013 />} />
        <Route path="/test/b090014" element={<B090014 />} />
        <Route path="/test/b090015" element={<B090015 />} />
        <Route path="/test/b090016" element={<B090016 />} />
        <Route path="/test/b090020" element={<B090020 />} />
        <Route path="/test/b090021" element={<B090021 />} />
        <Route path="/test/b090030" element={<B090030 />} />
        <Route path="/test/b090040" element={<B090040 />} />
        <Route path="/test/b090050" element={<B090050 />} />
        <Route path="/test/b090051" element={<B090051 />} />
        <Route path="/test/b090060" element={<B090060 />} />
        <Route path="/test/b100040" element={<B100040 />} />
        <Route path="/test/b100050" element={<B100050 />} />
        <Route path="/test/b100060" element={<B100060 />} />
        <Route path="/test/b100063" element={<B100063 />} />
        <Route path="/test/b100070" element={<B100070 />} />
        <Route path="/test/b100073" element={<B100073 />} />
        <Route path="/test/b100080" element={<B100080 />} />
        <Route path="/test/b100083" element={<B100083 />} />
        <Route path="/test/b100090" element={<B100090 />} />
        <Route path="/test/b100100" element={<B100100 />} />
        <Route path="/test/b100110" element={<B100110 />} />
        <Route path="/test/b100113" element={<B100113 />} />
        <Route path="/test/b100120" element={<B100120 />} />
        <Route path="/test/b100130" element={<B100130 />} />
        <Route path="/test/b100133" element={<B100133 />} />
        <Route path="/test/b100140" element={<B100140 />} />
        <Route path="/test/b100143" element={<B100143 />} />
        <Route path="/test/b100150" element={<B100150 />} />
        <Route path="/test/b100153" element={<B100153 />} />
        <Route path="/test/b100180" element={<B100180 />} />
        <Route path="/test/b100183" element={<B100183 />} />
        <Route path="/test/b100190" element={<B100190 />} />
        <Route path="/test/b100193" element={<B100193 />} />
        <Route path="/test/b100200" element={<></>} />
        <Route path="/test/b100210" element={<></>} />
        <Route path="/test/b100200" element={<B100200 />} />
        <Route path="/test/b100210" element={<B100210 />} />
        <Route path="/test/b100220" element={<B100220 />} />
        <Route path="/test/b100223" element={<B100223 />} />
        <Route path="/test/b100230" element={<B100230 />} />
        <Route path="/test/b100900" element={<B100900 />} />
        <Route path="/test/b100910" element={<B100910 />} />
        <Route path="/test/b110010" element={<B110010 />} />
        <Route path="/test/b110020" element={<B110020 />} />
        <Route path="/test/b110030" element={<B110030 />} />
        <Route path="/test/b110040" element={<B110040 />} />

        <Route path="/b000010" element={<B000010 />} />
        <Route path="/b000011" element={<B000011 />} />
        <Route path="/" element={<B000020 />} />
        <Route path="/b010010" element={<B000020 page={<B010010 />} />} />
        <Route path="/b010020" element={<B000020 page={<B010020 />} />} />
        <Route path="/b010030" element={<B000020 page={<B010030 />} />} />
        <Route path="/b010040" element={<B000020 page={<B010040 />} />} />
        <Route path="/b010050" element={<B000020 page={<B010050 />} />} />
        <Route path="/b010060" element={<B000020 page={<B010060 />} />} />
        <Route path="/b010070" element={<B000020 page={<B010070 />} />} />
        <Route path="/b010080" element={<B000020 page={<B010080 />} />} />
        <Route path="/b020010" element={<B000020 page={<B020010 />} />} />
        <Route path="/b020011" element={<B000020 page={<B020011 />} />} />
        <Route path="/b020012" element={<B000020 page={<B020012 />} />} />
        <Route path="/b020020" element={<B000020 page={<B020020 />} />} />
        <Route path="/b020030" element={<B000020 page={<B020030 />} />} />
        <Route path="/b020040" element={<B000020 page={<B020040 />} />} />
        <Route path="/b020050" element={<B000020 page={<B020050 />} />} />
        <Route path="/b030010" element={<B000020 page={<B030010 />} />} />
        <Route path="/b030020" element={<B000020 page={<B030020 />} />} />
        <Route path="/b030030" element={<B000020 page={<B030030 />} />} />
        <Route path="/b030040" element={<B000020 page={<B030040 />} />} />
        <Route path="/b030050" element={<B000020 page={<B030050 />} />} />
        <Route path="/b030051" element={<B000020 page={<B030051 />} />} />
        <Route path="/b030060" element={<B000020 page={<B030060 />} />} />
        <Route path="/b030070" element={<B000020 page={<B030070 />} />} />
        <Route path="/b030080" element={<B000020 page={<B030080 />} />} />
        <Route path="/b040010" element={<B000020 page={<B040010 />} />} />
        <Route path="/b040020" element={<B000020 page={<B040020 />} />} />
        <Route path="/b040030" element={<B000020 page={<B040030 />} />} />
        <Route path="/b040040" element={<B000020 page={<B040040 />} />} />
        <Route path="/b050010" element={<B000020 page={<B050010 />} />} />
        <Route path="/b050011" element={<B000020 page={<></>} />} />
        <Route path="/b050020" element={<B000020 page={<B050020 />} />} />
        <Route path="/b050030" element={<B000020 page={<B050030 />} />} />
        <Route path="/b060010" element={<B000020 page={<B060010 />} />} />
        <Route path="/b060020" element={<B000020 page={<B060020 />} />} />
        <Route path="/b060030" element={<B000020 page={<B060030 />} />} />
        <Route path="/b070010" element={<B000020 page={<B070010 />} />} />
        <Route path="/b070020" element={<B000020 page={<B070020 />} />} />
        <Route path="/b080010" element={<B000020 page={<B080010 />} />} />
        <Route path="/b080020" element={<B000020 page={<B080020 />} />} />
        <Route path="/b080030" element={<B000020 page={<B080030 />} />} />
        <Route path="/b080040" element={<B000020 page={<B080040 />} />} />
        <Route path="/b080050" element={<B000020 page={<B080050 />} />} />
        <Route path="/b080060" element={<B000020 page={<B080060 />} />} />
        <Route path="/b080070" element={<B000020 page={<B080070 />} />} />
        <Route path="/b080080" element={<B000020 page={<B080080 />} />} />
        <Route path="/b080090" element={<B000020 page={<B080090 />} />} />
        <Route path="/b090010" element={<B000020 page={<B090010 />} />} />
        <Route path="/b090011" element={<B000020 page={<B090011 />} />} />
        <Route path="/b090012" element={<B000020 page={<B090012 />} />} />
        <Route path="/b090013" element={<B000020 page={<B090013 />} />} />
        <Route path="/b090014" element={<B000020 page={<B090014 />} />} />
        <Route path="/b090015" element={<B000020 page={<B090015 />} />} />
        <Route path="/b090016" element={<B000020 page={<B090016 />} />} />
        <Route path="/b090020" element={<B000020 page={<B090020 />} />} />
        <Route path="/b090021" element={<B000020 page={<B090021 />} />} />
        <Route path="/b090030" element={<B000020 page={<B090030 />} />} />
        <Route path="/b090040" element={<B000020 page={<B090040 />} />} />
        <Route path="/b090050" element={<B000020 page={<B090050 />} />} />
        <Route path="/b090051" element={<B000020 page={<B090051 />} />} />
        <Route path="/b090060" element={<B000020 page={<B090060 />} />} />
        <Route path="/b100040" element={<B000020 page={<B100040 />} />} />
        <Route path="/b100050" element={<B000020 page={<B100050 />} />} />
        <Route path="/b100060" element={<B000020 page={<B100060 />} />} />
        <Route path="/b100063" element={<B000020 page={<B100063 />} />} />
        <Route path="/b100070" element={<B000020 page={<B100070 />} />} />
        <Route path="/b100073" element={<B000020 page={<B100073 />} />} />
        <Route path="/b100080" element={<B000020 page={<B100080 />} />} />
        <Route path="/b100083" element={<B000020 page={<B100083 />} />} />
        <Route path="/b100090" element={<B000020 page={<></>} />} />
        <Route path="/b100100" element={<B000020 page={<B100100 />} />} />
        <Route path="/b100110" element={<B000020 page={<B100110 />} />} />
        <Route path="/b100113" element={<B000020 page={<B100113 />} />} />
        <Route path="/b100120" element={<B000020 page={<B100120 />} />} />
        <Route path="/b100130" element={<B000020 page={<B100130 />} />} />
        <Route path="/b100133" element={<B000020 page={<B100133 />} />} />
        <Route path="/b100140" element={<B000020 page={<B100140 />} />} />
        <Route path="/b100143" element={<B000020 page={<B100143 />} />} />
        <Route path="/b100150" element={<B000020 page={<B100150 />} />} />
        <Route path="/b100153" element={<B000020 page={<B100153 />} />} />
        <Route path="/b100180" element={<B000020 page={<B100180 />} />} />
        <Route path="/b100183" element={<B000020 page={<B100183 />} />} />
        <Route path="/b100190" element={<B000020 page={<B100190 />} />} />
        <Route path="/b100193" element={<B000020 page={<B100193 />} />} />
        <Route path="/b100200" element={<B000020 page={<></>} />} />
        <Route path="/b100210" element={<B000020 page={<></>} />} />
        <Route path="/b100220" element={<B000020 page={<B100220 />} />} />
        <Route path="/b100223" element={<B000020 page={<B100223 />} />} />
        <Route path="/b100230" element={<B000020 page={<B100230 />} />} />
        <Route path="/b100900" element={<B000020 page={<B100900 />} />} />
        <Route path="/b100910" element={<B000020 page={<B100910 />} />} />
        <Route path="/b110010" element={<B000020 page={<B110010 />} />} />
        <Route path="/b110020" element={<B000020 page={<B110020 />} />} />
        <Route path="/b110030" element={<B000020 page={<B110030 />} />} />
        <Route path="/b110040" element={<B000020 page={<B110040 />} />} />
      </Routes>
    </BrowserRouter>
  );
};
